module.exports = __webpack_public_path__ + "img/2.3f49c673.jpg";